<span [style.background-color]="color()" class="inline-block w-2.5 h-2.5 rounded-full shrink-0"></span>
